import "./modules/slick-carousel";
import "./modules/wow-animation";

import "./components/_parallax-anim-svg";
import "./components/_qualityScripts";
import "./components/_outlets";
// import "./components/_osm_map";
// import "./components/google_map/_google_map";
import "./components/google_map/_map_filter";
import "./components/_faq_form";
import "./components/_rules_popup";
import "./components/_reg_and_auth";
import "./components/_promo_addresses_popup";
import "./components/_go-to-anchors";

import "./components/bn/fingerprint2";
import "./components/bn/stat";
import "./components/bn/mdetect";
import "./components/bn/bn";

import "./components/_user-calendar";
import "./components/_user_data";
import "./components/_profile_edit";
import "./components/_profile_form";

import './components/_select_multi';
